import { axiosClient } from './AxiosClient'

function listVisitorReport(page, size, callback, errorCallback){
    const url = '/visitor/list'
    const query = {
        page: page,
        size: size
    }
    axiosClient.get(url,{
        params: query
    })
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function countEntranceStat(callback, errorCallback){
    const url = '/visitor/stat/count_stat'
    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function countVisitorByMonth(callback, errorCallback){
    const url = '/visitor/stat/count_visitor_by_month'
    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function countVisitorByType(callback, errorCallback){
    const url = '/visitor/stat/count_type'
    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

export {
    listVisitorReport,
    countEntranceStat,
    countVisitorByMonth,
    countVisitorByType
}